module.exports = __webpack_public_path__ + "media/warning.dab4046e.mp3";